(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-filter-tab"] && !Shopify.designMode) return;
  try {
    
(function() {
  /**
   * Owl Carousel Dot Accessibility Fix
   * Adds aria-label to all .owl-dot buttons so screen readers
   * and PageSpeed Insights can identify them.
   */
  function labelOwlDots(carousel) {
    var dots = carousel.querySelectorAll('.owl-dot');
    dots.forEach(function(dot, index) {
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      // If the dot is active, mark it
      if (dot.classList.contains('active')) {
        dot.setAttribute('aria-current', 'true');
      }
    });
  }

  function initOwlDotFix() {
    // Wait for Owl Carousel to fully render its dots
    var carousels = document.querySelectorAll('.owl-carousel');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      // Use MutationObserver to catch dynamically injected dots
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            labelOwlDots(carousel);
          }
        });
      });

      observer.observe(carousel, { childList: true, subtree: true });

      // Also label any dots already present
      labelOwlDots(carousel);

      // Re-label on slide change (active dot changes)
      if (window.jQuery && jQuery(carousel).data('owl.carousel')) {
        jQuery(carousel).on('changed.owl.carousel', function() {
          // Update aria-current on active dot
          carousel.querySelectorAll('.owl-dot').forEach(function(dot, index) {
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.setAttribute('aria-current', dot.classList.contains('active') ? 'true' : 'false');
          });
        });
      }
    });
  }

  // Run after DOM and scripts are ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOwlDotFix);
  } else {
    initOwlDotFix();
  }

  // Fallback: also run after full page load (catches lazy-init carousels)
  window.addEventListener('load', initOwlDotFix);
})();

  } catch(e) { console.error(e); }
})();
})();
